import { render, staticRenderFns } from "./backHistory.vue?vue&type=template&id=9590766a&scoped=true&"
import script from "./backHistory.vue?vue&type=script&lang=js&"
export * from "./backHistory.vue?vue&type=script&lang=js&"
import style0 from "./backHistory.vue?vue&type=style&index=0&id=9590766a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9590766a",
  null
  
)

export default component.exports